<template>
  <div class="xp_wrapper">
    <span
      @click="pickme(p)"
      :class="p.cls"
      class="spanbutton"
      :key="p.txt"
      v-for="p in picks"
      >{{ p.txt }}</span
    >
  </div>
</template>

<script>
import * as R from "ramda";
export default {
  mounted() {
    let ps = this.w.split("|");
    ps = R.map((k) => {
      let p = {
        cls: "",
        txt: k,
      };
      return p;
    }, ps);
    this.picks = ps;
  },
  data() {
    return {
      picks: [],
    };
  },
  props: ["w"],

  methods: {
    pickme(p1) {
      // R.forEach((p) => {
      //   if (p.txt == p1.txt) {
      //     p.cls = "pick";
      //   } else {
      //     p.cls = "unpick";
      //   }
      // }, this.picks);

      if (p1.cls == "pick") {
        p1.cls = "unpick";
      } else {
        p1.cls = "pick";
      }
    },
  },
};
</script>


<style lang="scss" scoped>
.xp_wrapper {
  display: inline;
}
.spanbutton {
  margin-right: 5px;
  //   background-color: lightgray;
  cursor: pointer;
  font-size: 1.1em;
  padding: 1px 3px 1px 3px;
  background-color: lightgray;
}
.unpick {
  background-color: lightgray;
  //   color: grey;
  // font-size: 0.8em;
}
.hide {
  display: none;
}
.pick {
  background-color: cyan;
  // font-size: 1.2em;
}
</style>